import { Button, Checkbox, Col, Input, message, Popconfirm, Row, Select } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";

export default function CreateAdAccFullFunction(props) {
  const [loading, setLoading] = useState(false);
  const [profileModel, setProfileModel] = useState(testProfile);
  const [messageApi, contextHolder] = message.useMessage();

  const [quantity, setQuantity] = useState('5');
  const [tabs, setTabs] = useState('5');
  const [sleepStep, setSleepStep] = useState('3');
  const [sleepAcct, setSleepAcct] = useState('3');
  const [verifyDUNS, setVerifyDUNS] = useState(true);
  const [useOffer, setUseOffer] = useState(true);

  const [doFinish, setDoFinish] = useState(false);
  const [doAddVisa, setDoAddVisa] = useState(false);
  // sheet Profile info
  const [sheetProfileURL, setSheetProfileURL] = useState('');
  const [sheetProfileName, setSheetProfileName] = useState('Trang Tính1');
  // sheet visa
  const [sheetURL, setSheetURL] = useState('');
  const [sheetName, setSheetName] = useState('Trang Tính1');

  const [verifyPayment, setVerifyPayment] = useState(true);
  const [manual, setManual] = useState(true);
  const [stopAtAddVISA, setStopAtAddVISA] = useState(false);

  const create = async (profile) => {
    if (!sheetURL) {
      alert("Link GG Sheet VISA chưa nhập !!!")
      return;
    }
    if (!sheetProfileURL) {
      alert("Link GG Sheet Profile chưa nhập !!!")
      return;
    }

    messageApi.info(`Profile: ${profile.name} >>> Tạo TK Ad Full...`);
    let body = {
      profile: profile,
      sheet: {
        sheetId: sheetURL.split('/d/')[1].split('/edit')[0],
        sheetName: sheetName,
      },
      sheetProfile: {
        sheetId: sheetProfileURL.split('/d/')[1].split('/edit')[0],
        sheetName: sheetProfileName,
      },
      quantity,
      tabs,
      verifyDUNS,
      useOffer,
      doFinish,
      doAddVisa,
      sleepStep: +sleepStep * 1000,
      sleepAcct: +sleepAcct * 1000,
      verifyPayment,
      manual,
      stopAtAddVISA,
    };
    axios
      .post(`${API_HOST}/api/account/create-full`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ add-acct-full ~ e:", e);
        messageApi.error(e.response.data);
      });
  };
  useEffect(() => {
    let sheetName = localStorage.getItem('tkcn-sheetName')
    if (sheetName) {
      setSheetName(sheetName)
    }
    let sheetURL = localStorage.getItem('tkcn-sheetURL')
    if (sheetURL) {
      setSheetURL(sheetURL)
    }
    let sheetProfileURL = localStorage.getItem('tkcn-sheetProfileURL')
    if (sheetProfileURL) {
      setSheetProfileURL(sheetProfileURL)
    }
    let sheetProfileName = localStorage.getItem('tkcn-sheetProfileName')
    if (sheetProfileName) {
      setSheetProfileName(sheetProfileName)
    }
    let verifyDUNS = localStorage.getItem('tkcn-duns')
    if (verifyDUNS) {
      setVerifyDUNS(verifyDUNS === 'true')
    }
    let useOffer = localStorage.getItem('tkcn-useOffer')
    if (useOffer) {
      setUseOffer(useOffer === 'true')
    }
    let doFinish = localStorage.getItem('tkcn-doFinish')
    if (doFinish) {
      setDoFinish(doFinish === 'true')
    }
    let doAddVisa = localStorage.getItem('tkcn-doAddVisa')
    if (doAddVisa) {
      setDoAddVisa(doAddVisa === 'true')
    }
    let sleepStep = localStorage.getItem('tkcn-sleepStep')
    if (sleepStep) {
      setSleepStep(sleepStep)
    }
    let sleepAcct = localStorage.getItem('tkcn-sleepAcct')
    if (sleepAcct) {
      setSleepAcct(sleepAcct)
    }
    let tabs = localStorage.getItem('tkcn-tabs')
    if (tabs) {
      setTabs(tabs)
    }
    let quantity = localStorage.getItem('tkcn-quantity')
    if (quantity) {
      setQuantity(quantity)
    }

    let verifyPayment = localStorage.getItem('tkcn-verifyPayment')
    if (verifyPayment) {
      setVerifyPayment(verifyPayment === 'true')
    }
    let manual = localStorage.getItem('tkcn-manual')
    if (manual) {
      setManual(manual === 'true')
    }
    let stopAtAddVISA = localStorage.getItem('tkcn-stopAtAddVISA')
    if (stopAtAddVISA) {
      setStopAtAddVISA(stopAtAddVISA === 'true')
    }

  }, [])

  const onOpenChange = (open) => {
    if (open) {
      setLoading(true);
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          setLoading(false);
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          setLoading(false);
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: '500px' }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Tạo TK Ad Full"
        description={
          <div style={{ width: '500px' }}>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}
            <Row>
              <Col span={10}>
                <label>Số Lượng: </label>
              </Col>
              <Col span={14}>
                <Input
                  value={quantity}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Số Lượng ..."
                  onChange={(e) => {
                    setQuantity(e.target.value)
                    localStorage.setItem("tkcn-quantity", e.target.value);
                  }}
                />
              </Col>
              <Col span={10}>
                <label>Số Tab: </label>
              </Col>
              <Col span={14}>
                <Input
                  value={tabs}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Số Lượng Tab ..."
                  onChange={(e) => {
                    setTabs(e.target.value);
                    localStorage.setItem("tkcn-tabs", e.target.value);
                  }}
                />
              </Col>

              <Col span={10}>
                <label>Nghỉ Sau Mỗi Bước: (giây)</label>
              </Col>
              <Col span={14}>
                <Input
                  value={sleepStep}
                  style={{ width: 60 }}
                  placeholder="Giây ..."
                  onChange={(e) => {
                    setSleepStep(e.target.value)
                    localStorage.setItem("tkcn-sleepStep", e.target.value);
                  }}
                />
              </Col>
              <Col span={10}>
                <label>Nghỉ Sau Mỗi TK: (giây)</label>
              </Col>
              <Col span={14}>
                <Input
                  value={sleepAcct}
                  style={{ width: 60 }}
                  placeholder="Số Giây ..."
                  onChange={(e) => {
                    setSleepAcct(e.target.value)
                    localStorage.setItem("tkcn-sleepAcct", e.target.value);
                  }}
                />
              </Col>
              <Col span={10}>
                <label>Xác Minh D.U.N.S</label>
              </Col>
              <Col span={14}>
                <Checkbox checked={verifyDUNS} onChange={e => {
                  setVerifyDUNS(e.target.checked)
                  localStorage.setItem("tkcn-duns", e.target.checked + '');
                }}>
                </Checkbox>
              </Col>
              <Col span={10}>
                <label>Tạo từ Offer</label>
              </Col>
              <Col span={14}>
                <Checkbox checked={useOffer} onChange={e => {
                  setUseOffer(e.target.checked)
                  localStorage.setItem("tkcn-useOffer", e.target.checked + '');
                }}>
                </Checkbox>
              </Col>
              <Col span={10}>
                <label>Xác Minh VISA</label>
              </Col>
              <Col span={14}>
                <Checkbox checked={verifyPayment} onChange={e => {
                  setVerifyPayment(e.target.checked)
                  localStorage.setItem("tkcn-verifyPayment", `${e.target.checked}`);
                }}>
                </Checkbox>
              </Col>
              <Col span={10}>
                <label>Lấy CODE Thủ Công</label>
              </Col>
              <Col span={14}>
                <Checkbox checked={manual} onChange={e => {
                  setManual(e.target.checked);
                  localStorage.setItem("tkcn-manual", `${e.target.checked}`);
                }}>
                </Checkbox>
              </Col>
              <Col span={10}>
                <label>SUBMIT : Sau Khi thêm VISA</label>
              </Col>
              <Col span={14}>
                <Checkbox checked={!stopAtAddVISA} onChange={e => {
                  setStopAtAddVISA(!e.target.checked)
                  localStorage.setItem("tkcn-stopAtAddVISA", `${!e.target.checked}`);
                }}>
                </Checkbox>
              </Col>


              <Col span={24}>***</Col>
              <Col span={10}>
                <label><b>Hoàn Thành TK Nháp</b></label>
              </Col>
              <Col span={14}>
                <Checkbox checked={doFinish} onChange={e => {
                  setDoFinish(e.target.checked)
                  setDoAddVisa(e.target.checked ? false : doAddVisa)
                  localStorage.setItem("tkcn-doFinish", e.target.checked + '');
                }}>
                </Checkbox>
              </Col>
              <Col span={24}>***</Col>
              <Col span={10}>
                <label><b>Thêm VISA TK Active</b></label>
              </Col>
              <Col span={14}>
                <Checkbox checked={doAddVisa} onChange={e => {
                  setDoAddVisa(e.target.checked)
                  setDoFinish(e.target.checked ? false : doFinish)
                  localStorage.setItem("tkcn-doAddVisa", e.target.checked + '');
                }}>
                </Checkbox>
              </Col>
              <Col span={24}>***</Col>
            </Row>

            <br></br>
            <b style={{ color: 'red' }}>GG sheet VISA: </b>
            <Row>
              <Col span={2}>
                <label>URL: </label>
              </Col>
              <Col span={22}>
                <Input
                  value={sheetURL}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL(e.target.value);
                    localStorage.setItem('tkcn-sheetURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={2}>
                <label>Trang: </label>
              </Col>
              <Col span={22}>
                <Input
                  value={sheetName}
                  style={{ width: 200 }}
                  placeholder="SheetName visa..."
                  onChange={(e) => {
                    setSheetName(e.target.value);
                    localStorage.setItem('tkcn-sheetName', e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br></br>
            <b style={{ color: 'blue' }}>GG sheet Profile <i>(Cột I: Quốc Gia -{'>'} Lấy theo Quốc Gia của VISA)</i>: </b>
            <Row>
              <Col span={2}>
                <label>URL: </label>
              </Col>
              <Col span={22}>
                <Input
                  value={sheetProfileURL}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetProfileURL(e.target.value);
                    localStorage.setItem('tkcn-sheetProfileURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={2}>
                <label>Trang: </label>
              </Col>
              <Col span={22}>
                <Input
                  value={sheetProfileName}
                  style={{ width: 200 }}
                  placeholder="SheetName profile..."
                  onChange={(e) => {
                    setSheetProfileName(e.target.value);
                    localStorage.setItem('tkcn-sheetProfileName', e.target.value);
                  }}
                />
              </Col>
            </Row>
          </div>
        }
        onConfirm={() => create(props.profile)}
      >
        <Button type="primary" style={{ color: 'white' }} loading={loading}>
          <b>Tạo TK Ad Full</b>
        </Button>
      </Popconfirm>
    </>
  );
}
